// Contest referral link (?ref=CODE): remember the code when someone lands on the app through a
// shared link, then send it with their registration. Stored for 30 days; never trusted — the
// server validates it (and ignores self/invalid referrals).

const KEY = 'sk_ref';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const CODE_RE = /^[A-Za-z0-9]{4,16}$/;

/** Call once on app start: saves a valid ?ref= value from the current URL. */
export function captureReferralFromUrl() {
    try {
        const code = new URLSearchParams(window.location.search).get('ref');
        if (code && CODE_RE.test(code)) {
            localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), at: Date.now() }));
        }
    } catch { /* storage unavailable — referral simply isn't remembered */ }
}

/** The remembered referral code (or null when missing/expired). */
export function getStoredReferral() {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (raw?.code && CODE_RE.test(raw.code) && Date.now() - (raw.at || 0) < TTL_MS) return raw.code;
    } catch { /* ignore */ }
    return null;
}

/** Add `referralCode` to a registration payload when one is remembered. */
export function withReferral(payload) {
    const code = getStoredReferral();
    return code ? { ...payload, referralCode: code } : payload;
}

export function clearStoredReferral() {
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
